<div
    class="tw-relative tw-bg-white tw-rounded-2xl tw-w-full tw-mx-auto tw-max-h-[90vh] tw-overflow-y-auto"
>
    <div>
        <button
            (click)="closeDialog()"
            class="tw-absolute tw-right-4 tw-top-4 tw-text-black tw-text-2xl tw-z-10"
            aria-label="Close dialog"
        >
            ✕
        </button>
    </div>

    <div class="tw-p-6 tw-overflow-y-auto tw-my-5">
        <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-gap-[20px] tw-items-center md:tw-items-start tw-text-center md:tw-text-left"
        >
            <!-- Bank Logo -->
            <div
                class="tw-w-[256px] tw-h-[159px] tw-border tw-border-[#D9D9D9] tw-rounded-[20px] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-p-5"
            >
                <img
                    [src]="data.prodImage"
                    alt="Affin Bank Logo"
                    class="tw-w-[140px] tw-h-auto tw-max-w-full tw-max-h-full tw-object-contain"
                />
            </div>

            <div class="tw-flex-1 tw-rounded-[4px] tw-p-[16px]">
                <p
                    class="tw-text-xl tw-font-semibold tw-text-[#000000] tw-leading-[22px] tw-mb-[12px]"
                >
                    {{ data.productName }}
                </p>

                <p
                    class="tw-hidden md:tw-flex tw-items-center tw-text-sm tw-font-semibold tw-mb-[8px]"
                >
                    <span class="tw-text-[#00000080] !tw-mr-[12px]"
                        >{{ "COMMON.STATUS" | translate }}:</span
                    >
                    <span
                        class="tw-bg-[#FF88191A] tw-text-[#F57300] tw-px-[8px] tw-py-[4px] tw-rounded-full"
                    >
                        {{ data.cCaseStatus | translate }}
                    </span>
                </p>

                <p class="tw-hidden md:tw-block tw-text-sm tw-mb-[8px]">
                    <span
                        class="tw-text-[#00000080] tw-font-semibold !tw-mr-[12px]"
                        >{{ "COMMON.RECENT_APPID" | translate }}:</span
                    >
                    <span class="tw-text-[#000000] tw-font-normal">
                        {{ data.cCaseAppNo }}</span
                    >
                </p>

                <p class="tw-hidden md:tw-block tw-text-sm">
                    <span
                        class="tw-text-[#00000080] tw-font-semibold !tw-mr-[12px]"
                        >{{ "COMMON.APP_DATE_N_TIME" | translate }}:</span
                    >
                    <span class="tw-text-[#000000] tw-font-normal">
                        {{ data.createdDateTime }}</span
                    >
                </p>
            </div>
        </div>
        <!-- Products list -->
        <div>
            <!-- Desktop Table only -->
            <table
                class="tw-w-full tw-border-spacing-2 tw-border-separate md:tw-table tw-hidden"
            >
                <thead>
                    <tr>
                        <th
                            class="tw-bg-gray-100 !tw-p-3 tw-text-left tw-w-[30%] !tw-mx-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "COMMON.FINANCING" | translate }}
                            </div>
                        </th>
                        <th
                            class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[25%] tw-mx-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.PROCESSING" | translate }}
                            </div>
                        </th>
                        <th
                            class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[25%] tw-mx-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.TENURE" | translate }}
                            </div>
                        </th>
                        <th
                            class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[20%] tw-mx-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.INTEREST" | translate }}
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="tw-p-3">
                            <div class="tw-font-bold tw-text-[14px]">
                                <span>{{
                                    getFormattedCurrency(
                                        data?.productValidation?.financeAmount
                                            ?.min
                                    )
                                }}</span>
                                - <br />
                                <span>{{
                                    getFormattedCurrency(
                                        data?.productValidation?.financeAmount
                                            ?.max
                                    )
                                }}</span>
                            </div>
                            <div class="tw-text-xs tw-text-gray-500">
                                {{ "NEW_PRODUCTS.STARTS_FROM" | translate }}
                            </div>
                        </td>
                        <td class="tw-p-3">
                            <div class="tw-font-bold tw-text-[14px]">
                                {{ data.prodTat }}
                                {{ "WORKING_DAYS" | translate }}
                            </div>
                        </td>
                        <td class="tw-p-3">
                            <div class="tw-font-bold tw-text-[14px]">
                                {{ data?.productValidation?.tenure?.max }}
                                <span>
                                    {{
                                        data?.productValidation?.tenure?.unit
                                            | uppercase
                                            | translate
                                    }}
                                </span>
                            </div>
                        </td>
                        <td class="tw-p-3">
                            <div class="tw-font-bold tw-text-[14px]">
                                {{ data?.prodAvgIr }} %
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- Mobile Table -->
            <div class="md:tw-hidden tw-block tw-mb-6">
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                    <!-- Row 1: Financing and Processing -->
                    <div>
                        <div
                            class="tw-bg-gray-100 tw-px-3 tw-py-1 md:tw-py-3 tw-mx-0"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "COMMON.FINANCING" | translate }}
                            </div>
                        </div>
                        <div class="tw-p-3 tw-border-t tw-border-gray-200">
                            <div class="tw-font-bold tw-text-[14px]">
                                <span>{{
                                    getFormattedCurrency(
                                        data?.productValidation?.financeAmount
                                            ?.min
                                    )
                                }}</span>
                                - <br />
                                <span>{{
                                    getFormattedCurrency(
                                        data?.productValidation?.financeAmount
                                            ?.max
                                    )
                                }}</span>
                            </div>
                            <div class="tw-text-xs tw-text-gray-500">
                                {{ "NEW_PRODUCTS.STARTS_FROM" | translate }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            class="tw-bg-gray-100 tw-px-3 tw-py-1 md:tw-py-3 tw-mx-0"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.PROCESSING" | translate }}
                            </div>
                        </div>
                        <div class="tw-p-3 tw-border-t tw-border-gray-200">
                            <div class="tw-font-bold tw-text-[14px]">
                                {{ data.prodTat }}
                                {{ "WORKING_DAYS" | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Row 2: Tenure and Interest -->
                    <div>
                        <div
                            class="tw-bg-gray-100 tw-px-3 tw-py-1 md:tw-py-3 tw-mx-0 tw-mt-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.TENURE" | translate }}
                            </div>
                        </div>
                        <div class="tw-p-3 tw-border-t tw-border-gray-200">
                            <div
                                class="tw-font-bold tw-text-[14px] tw-flex tw-items-center tw-gap-[1px]"
                            >
                                <span>{{
                                    data?.productValidation?.tenure?.max
                                }}</span>
                                <span>
                                    {{
                                        data?.productValidation?.tenure?.unit
                                            | uppercase
                                            | translate
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            class="tw-bg-gray-100 tw-px-3 tw-py-1 md:tw-py-3 tw-mx-0 tw-mt-2"
                        >
                            <div class="tw-text-gray-600 tw-text-sm">
                                {{ "NEW_PRODUCTS.INTEREST" | translate }}
                            </div>
                        </div>
                        <div class="tw-p-3 tw-border-t tw-border-gray-200">
                            <div class="tw-font-bold tw-text-[14px]">
                                {{
                                    data?.selectedLanguage === "bm"
                                        ? data?.prodIrBm
                                        : data?.prodIr
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="tw-hidden md:tw-block tw-mt-1" />
            <!-- Application Information Section -->
            <div
                class="!tw-mt-5 tw-hidden md:tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4"
            >
                <div class="tw-col-span-1">
                    <span class="tw-font-semibold tw-text-sm"
                        >{{
                            "COMMON.APPLICANTION_INFORMATION" | translate
                        }}:</span
                    >
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "BUMIPUTERA_STATUS" | translate }}</span
                    >
                    <div>
                        <!-- class="tw-h-[53px] tw-flex tw-flex-col tw-justify-end" -->
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getBumiputeraStatus(data.cCaseBumi) | translate
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-semibold tw-text-sm"
                        *ngIf="data.activeTab === 'portfolio'"
                        >{{
                            "DASHBOARD.DASHBOARD_MAIN.APP_APPLIED_VIA"
                                | translate
                        }}</span
                    >
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-text-sm tw-text-gray-700"
                        *ngIf="data.activeTab === 'portfolio'"
                        >{{ "COMMON.CGC_BRANCH" | translate }}</span
                    >
                    <div *ngIf="data.activeTab === 'portfolio'">
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                            >{{ data.cCaseBranch }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
            </div>
            <!-- Business Information -->
            <div
                class="!tw-mt-5 tw-hidden md:tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4"
            >
                <div class="tw-col-span-1">
                    <span class="tw-font-semibold tw-text-sm"
                        >{{ "COMMON.BUSINESS_INFORMATION" | translate }}:</span
                    >
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.BUSINESS_NAME" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                            >{{ this.getBizName(data.cCaseBizName) }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                    >
                        {{
                            data.cCaseBizConst === "IND"
                                ? ("COMMON.INDIVIDUAL_NRIC" | translate)
                                : ("COMMON.REGISTRATION_NUMBER_NEW" | translate)
                        }}
                    </span>
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{ getBizRegOrNric(data) }}
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.BUSINESS_CONSTITUTION" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                            >{{
                                getBusinessConstitutionValue(data.cCaseBizConst)
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>

                <div class="tw-col-span-1"></div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.SECTOR_BIZ_ACTIVITY" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getBusinessSector(data.cCaseBizSector)
                                    | translate
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.PROFITABILITY_TREND" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            <span
                                *ngIf="getBizProfitLabel(data) as profitability"
                            >
                                {{
                                    profitability === "N/A"
                                        ? profitability
                                        : (profitability | translate)
                                }}
                            </span>
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{
                            "COMMON.TTL_ANNUAL_SALES_LATEST" | translate
                        }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getFormattedCurrency(data.cCaseSalesTurnover)
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>

                <!-- Row 3 -->
                <div class="tw-col-span-1"></div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{
                            "COMMON.MONTHLY_LOAN_INSTALLMENT" | translate
                        }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getFormattedCurrency(data.cCaseMthLnInst)
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ getBizOperationHeader(data) | translate }}</span
                    >
                    <div>
                        <span
                            *ngIf="
                                getBizOperationLabel(data) as bizOperationYrs
                            "
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            <!-- <div
        class="tw-font-semibold tw-text-caption-gray tw-pb-[9px] tw-text-[14px] lg:tw-text-[12px] xl:tw-text-[16px] md:tw-text-[18px] xl:tw-w-8/12"
       
        > -->
                            {{ bizOperationYrs | translate }}
                            <!-- </div> -->
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.PAID_UP_CAPITAL" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{ getFormattedCurrency(data.cCasePaidupCapital) }}
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>

                <!-- Row 4 -->
                <div class="tw-col-span-1"></div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                    >
                        {{ "COMMON.NET_INCOME" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getFormattedCurrency(data.cCaseNetIncome)
                            }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
            </div>
            <!-- Financing Details -->
            <div
                class="!tw-mt-5 tw-hidden md:tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4"
            >
                <div class="tw-col-span-1">
                    <span class="tw-font-semibold tw-text-sm"
                        >{{ "COMMON.FINANCING_DETAILS" | translate }}:</span
                    >
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{
                            "NEW_APPLICATION.PURPOSE_OF_FINANCING" | translate
                        }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{
                                getPurposeOfFinancing(data.cCasePof) | translate
                            }}
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.TENURE" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex tw-gap-[4px]"
                        >
                            <span *ngIf="data?.cCasePof !== 'TF' || 'RC'">
                                {{ data.cCaseTenure }}
                            </span>
                            <span *ngIf="data?.cCasePof == 'TF' || 'RC'">{{
                                data.cCaseTenureUnit
                                    .split("-")
                                    .slice(0, 2)
                                    .join(" - ")
                                    | uppercase
                                    | translate
                            }}</span>
                            <span>&nbsp;</span>
                            <span>{{
                                data.cCaseTenureUnit
                                    .split("-")
                                    .slice(2)
                                    .join("")
                                    | uppercase
                                    | translate
                            }}</span>
                        </span>
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.FINANCING_AMOUNT" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                        >
                            {{ getFormattedCurrency(data.cCaseFinamt) }}</span
                        >
                        <hr class="tw-mt-3" />
                    </div>
                </div>
                <div class="tw-col-span-1"></div>
                <div class="tw-col-span-1">
                    <span
                        class="tw-font-medium tw-text-sm tw-text-[#7B7575] tw-block tw-min-h-[42px]"
                        >{{ "COMMON.APPROVED_AMOUNT" | translate }}</span
                    >
                    <div>
                        <span
                            class="tw-font-normal tw-text-base tw-text-black tw-h-[43px] tw-flex"
                            >{{
                                getFormattedCurrency(data.cCaseApproveAmt)
                            }}</span
                        >
                        <hr class="!tw-mb-5" />
                    </div>
                </div>

                <ng-container *ngIf="data.documents.length > 0">
                    <!-- Document section starts (business/branch)  -->
                    <ng-container
                        *ngIf="
                            activeTab === 'business' || activeTab === 'branch'
                        "
                    >
                        <!-- Document Row 1-->
                        <div class="tw-col-span-1"></div>
                        <div class="tw-col-span-1"></div>
                        <div class="tw-col-span-1"></div>
                        <!-- Bank Statement -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="
                                    getDocInfo('BANK_STATEMENT');
                                    else consentError
                                "
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.BANK_STATEMENT }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('BANK_STATEMENT');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('BANK_STATEMENT')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("BANK_STATEMENT")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- SSM Certificate -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="getDocInfo('SSM_DOC'); else consentError"
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.SSM_DOC }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('SSM_DOC');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('SSM_DOC')?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("SSM_DOC")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- Proof of Address -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="
                                    getDocInfo('PROOF_OF_ADDRESS');
                                    else consentError
                                "
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.PROOF_OF_ADDRESS }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('PROOF_OF_ADDRESS');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('PROOF_OF_ADDRESS')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("PROOF_OF_ADDRESS")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>
                    <!-- Document section ends (business/branch)-->

                    <!-- Document section starts (portfolio)  -->
                    <ng-container *ngIf="data.activeTab === 'portfolio'">
                        <!-- Document Row 1-->
                        <div class="tw-col-span-1"></div>
                        <div class="tw-col-span-1"></div>
                        <div class="tw-col-span-1"></div>
                        <!-- Declaration Form -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="
                                    getDocInfo('CONSENT_DOC');
                                    else consentError
                                "
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.CONSENT_DOC }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('CONSENT_DOC');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('CONSENT_DOC')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("CONSENT_DOC")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- SSM Certificate -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="getDocInfo('SSM_DOC'); else consentError"
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.SSM_DOC }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('SSM_DOC');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('CONSENT_DOC')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("SSM_DOC")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- Proof of Address -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="
                                    getDocInfo('PROOF_OF_ADDRESS');
                                    else consentError
                                "
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.PROOF_OF_ADDRESS }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('PROOF_OF_ADDRESS');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('PROOF_OF_ADDRESS')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("PROOF_OF_ADDRESS")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- Document Row 2-->
                        <div class="tw-col-span-1"></div>
                        <!-- Bank Statement -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="
                                    getDocInfo('BANK_STATEMENT');
                                    else consentError
                                "
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.BANK_STATEMENT }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('BANK_STATEMENT');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('BANK_STATEMENT')
                                                    ?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("BANK_STATEMENT")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- IC -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="getDocInfo('NRIC'); else consentError"
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.NRIC }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('NRIC');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('NRIC')?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("NRIC")?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- CCRIS -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="getDocInfo('CCRIS'); else consentError"
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.CCRIS }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('CCRIS');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('CCRIS')?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("CCRIS")
                                                ?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                        <!-- Document Row 3-->
                        <div class="tw-col-span-1"></div>
                        <!-- CTOS -->
                        <div
                            class="tw-col-span-1 tw-flex tw-items-start tw-gap-2"
                        >
                            <mat-icon
                                *ngIf="getDocInfo('CTOS'); else consentError"
                                class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#009402] tw-text-[#009402] tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                            >
                                check
                            </mat-icon>
                            <ng-template #consentError>
                                <div
                                    class="tw-w-[24px] tw-h-[24px] tw-bg-white tw-border-2 tw-border-[#7B7575] tw-text-red-500 tw-text-[20px] tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-mt-[4px]"
                                ></div>
                            </ng-template>
                            <div>
                                <span
                                    class="tw-font-medium tw-text-base tw-text-[#7B7575]"
                                >
                                    {{ aliasLabelMap.CTOS }}</span
                                >
                                <div
                                    *ngIf="
                                        getDocInfo('CTOS');
                                        else consentUpload
                                    "
                                >
                                    <a
                                        class="tw-font-medium tw-text-sm tw-text-blue-600 hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(
                                                getDocInfo('CTOS')?.docsId
                                            )
                                        "
                                    >
                                        {{
                                            getDocInfo("CTOS")?.originalfilename
                                        }}
                                    </a>
                                    <hr class="tw-mt-3" />
                                </div>
                                <ng-template #consentUpload>
                                    <div class="tw-flex tw-items-center">
                                        <mat-icon
                                            class="tw-text-red-500 tw-text-[18px]"
                                            >error_outline</mat-icon
                                        >
                                        <span
                                            class="tw-font-medium tw-text-sm tw-text-black hover:tw-underline cursor-pointer"
                                        >
                                            {{
                                                "COMMON.UPLOAD_DOCUMENT"
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <hr class="tw-mt-3" />
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>
                    <!-- Document section ends (portfolio)-->
                </ng-container>
            </div>
            <div
                *ngIf="data.documents.length > 0"
                class="!tw-my-5 tw-hidden md:tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4"
            >
                <div class=""></div>
                <div
                    class="tw-col-span-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4"
                >
                    <div
                        class="tw-flex tw-items-center tw-gap-2 tw-pb-5 tw-border-b tw-border-b-gray-300"
                        *ngFor="let item of data.documents"
                    >
                        <div
                            class="tw-h-[24px] tw-w-[24px] tw-flex tw-items-center tw-justify-center tw-border tw-border-green-500"
                        >
                            <mat-icon
                                class="tw-text-green-500 !tw-text-lg !tw-h-[28px] !tw-w-[20px]"
                                >check</mat-icon
                            >
                        </div>
                        <div class="tw-flex tw-flex-col tw-w-full">
                            <span class="tw-text-gray-500 tw-text-[12px]">{{
                                item?.alias?.replaceAll("_", " ")
                            }}</span>
                            <span class="tw-text-[#0A0A75]">{{
                                item.originalfilename
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Download button -->
        <div class="tw-flex tw-justify-center !tw-mt-5">
            <button
                class="tw-bg-[#0A0A75] tw-rounded-[30px] tw-py-[10px] tw-px-[20px] tw-flex tw-items-center tw-gap-[10px] tw-text-white tw-font-semibold tw-text-base hover:tw-opacity-90"
                (click)="downloadAsPdf(data)"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-w-[24px] tw-h-[24px]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                {{
                    "DASHBOARD.DASHBOARD_MAIN.DOWNLOAD_FORM_DETAILS" | translate
                }}
            </button>
        </div>
    </div>
</div>
